<div style="display: flex; justify-content: space-between;">
  <h2 style="font-weight: bold; margin: 0px;">Vendor Login</h2>
  <mat-icon class="close-icon" mat-dialog-close>close</mat-icon>
</div>

<div class="login-box">
  <div class="login-image">
    <img src="../../../../../assets/contractx logo2.png" alt="login icon" />
    <h3 class="navbar-brand">
      Align<span style="color: #f7ba00; font-size: 23px;">Master</span>
    </h3>
  </div>

  <form (ngSubmit)="loginHandler(form, $event)" #form="ngForm" autocomplete="off">
    <!-- Email -->
    <div class="input-container">
      <input
        type="email"
        placeholder="Business Email"
        id="email"
        name="email"
        [(ngModel)]="user.email"
        required
        pattern=".+@.+\..+"
        #email="ngModel"
      />
      <mat-error *ngIf="email.invalid && (email.touched || email.dirty)">
        Please enter a valid email.
      </mat-error>
    </div>

    <!-- Password -->
    <div class="input-container">
      <input
        type="password"
        id="password"
        name="password"
        placeholder="Password"
        [(ngModel)]="user.password"
        required
        minlength="6"
        #password="ngModel"
      />
      <mat-error *ngIf="password.invalid && (password.touched || password.dirty)">
        Password required
      </mat-error>
    </div>

    <button class="login-button" [disabled]="isSubmitting">Login</button>
     <div class="text-center" style="margin: 15px auto">
      By continuing, you agree to Alignmaster's
      <a routerLink="/auth/termsandcondition" mat-dialog-close="true">Terms of Service</a>
      and acknowledge you've read our
      <a routerLink="/auth/privacypolicy" mat-dialog-close="true">Privacy Policy</a>
    </div>
    <mat-divider></mat-divider>
    <a class="create-account-link" (click)="openCreatemyaccountbox()">
      Not a member? Create your Account
    </a>
  </form>
</div>
